import { Col, Form, Select } from "antd";
import { useCallback, useEffect, useState } from "react";
import debounce from "lodash.debounce";
import { ALL_SUB_STYLES } from "../../../apiServices/API_ENDPOINTS";
import { getData } from "../../../apiServices/common";
import { isArrayAndHasValue } from "../../../utils/functions";

const SubStyleFilterCol = ({
  filterClearTrigger = 0,
  styleFieldName = "style_id",
  colSpan = 4,
  name = "sub_style_id",
}) => {
  const { Option } = Select;
  const styleIdWatch = Form.useWatch(styleFieldName);
  const [subStyleList, setSubStyleList] = useState([]);

  const fetchSubStyleList = async (filterValues = {}) => {
    const bodyData = {
      per_page: 10,
      page: 1,
      ...filterValues,
    };
    const response = await getData(ALL_SUB_STYLES, false, bodyData);

    if (response && response?.data?.code === 200) {
      setSubStyleList(response?.data?.data?.data || []);
    }
  };

  const getSubStyleList = useCallback(debounce(fetchSubStyleList, 300), []);

  useEffect(() => {
    fetchSubStyleList();
  }, []);

  useEffect(() => {
    if (styleIdWatch) {
      fetchSubStyleList({ style_id: styleIdWatch });
    }
  }, [styleIdWatch]);

  useEffect(() => {
    if (filterClearTrigger > 0) {
      getSubStyleList.cancel();
      fetchSubStyleList();
    }
  }, [filterClearTrigger]);

  return (
    <Col span={colSpan}>
      <Form.Item label="Sub Style" name={name}>
        <Select
          showSearch
          placeholder="Search Sub Style"
          filterOption={false}
          size="small"
          allowClear
          onClear={() => {
            getSubStyleList.cancel();
            fetchSubStyleList();
          }}
          onSearch={(value) =>
            getSubStyleList({
              sub_style_no: value,
              style_id: styleIdWatch || null,
            })
          }
        >
          {isArrayAndHasValue(subStyleList) &&
            subStyleList.map((item) => (
              <Option value={item.id} key={item.id}>
                {item.sub_style_no}
              </Option>
            ))}
        </Select>
      </Form.Item>
    </Col>
  );
};

export default SubStyleFilterCol;
